import React from "react";

const SourceIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.73558 2.77344C5.77365 2.77344 2.5625 5.98459 2.5625 9.94652C2.5625 13.9084 5.77365 17.1196 9.73558 17.1196C13.6975 17.1196 16.9087 13.9084 16.9087 9.94652C16.9087 5.98459 13.6975 2.77344 9.73558 2.77344ZM9.73558 15.9241C6.43955 15.9241 3.75801 13.2425 3.75801 9.94652C3.75801 6.65049 6.43955 3.96895 9.73558 3.96895C13.0316 3.96895 15.7131 6.65049 15.7131 9.94652C15.7131 13.2425 13.0316 15.9241 9.73558 15.9241ZM6.14904 9.94652C6.14904 10.4175 6.24181 10.8839 6.42205 11.319C6.60229 11.7542 6.86647 12.1495 7.19951 12.4826C7.53255 12.8156 7.92793 13.0798 8.36307 13.26C8.79821 13.4403 9.26459 13.5331 9.73558 13.5331C10.6868 13.5331 11.599 13.1552 12.2716 12.4826C12.9443 11.81 13.3221 10.8977 13.3221 9.94652C13.3221 8.99531 12.9443 8.08306 12.2716 7.41045C11.599 6.73784 10.6868 6.35998 9.73558 6.35998C8.78437 6.35998 7.87212 6.73784 7.19951 7.41045C6.52691 8.08306 6.14904 8.99531 6.14904 9.94652Z"
        fill="#100A0A"
      />
    </svg>
  );
};

export default SourceIcon;
